//import Tobii from '@midzer/tobii';
import Collapse from 'bootstrap/js/dist/collapse';
import Cookieman from './cookieman.js';

export {
    Collapse,
    Cookieman,
};

/*
 * login toggle
 */
let userLogin = document.getElementById('userLoginForm');

let companyLogin = document.getElementById('companyLoginForm');

let userLoginToggle = document.getElementById('userLoginToggle');

let companyLoginToggle = document.getElementById('companyLoginToggle');

let toggleClass = 'loginToggle';

if (document.body.contains(userLoginToggle)) {
    userLoginToggle.addEventListener('click', onClick);
    showUserLoginForm();
}
if (document.body.contains(companyLoginToggle)) {
    companyLoginToggle.addEventListener('click', onClick);
}

function onClick(e) {
    if (e.target.className.indexOf(toggleClass) === -1) return;
    e.preventDefault();
    if (e.target.id === 'userLoginToggle') {
        showUserLoginForm();
    }
    if (e.target.id === 'companyLoginToggle') {
        showCompanyLoginForm();
    }
}

function showUserLoginForm() {
    userLoginToggle.classList.add('activeTab');
    userLogin.style.display = 'block';
    companyLoginToggle.classList.remove('activeTab');
    companyLogin.style.display = 'none';
}

function showCompanyLoginForm() {
    companyLoginToggle.classList.add('activeTab');
    companyLogin.style.display = 'block';
    userLoginToggle.classList.remove('activeTab');
    userLogin.style.display = 'none';
}

/*
 * main-nav toggle
 */
document.addEventListener("DOMContentLoaded", function () {
    let mobileToggle = document.getElementById('main-nav-toggle-mobile');

    mobileToggle.addEventListener('click', function() {
        document.body.classList.toggle('mobile-main-nav--open');
    });
});

/*
 * lightbox init
 */
/* eslint-disable */
//const tobii = new Tobii();
/* eslint-enable */

/**
 * Submenu toggle
 */
let submenuToggles = document.getElementsByClassName('main-nav-list__item--has-sub');

for (let i = 0; i < submenuToggles.length; i++) {
    submenuToggles[i].addEventListener('click', function() {
        for (let j = 0; j < submenuToggles.length; j++) {
            if (j != i) {
                submenuToggles[j].classList.remove('sub-nav--open');
            }
        }
        submenuToggles[i].classList.toggle('sub-nav--open');
    });
}

/**
 * Langnav toggle
 */
let langmenuToggles = document.getElementsByClassName('lang-nav-list__item--has-sub');

for (let i = 0; i < langmenuToggles.length; i++) {
    langmenuToggles[i].addEventListener('click', function() {
        langmenuToggles[i].classList.toggle('lang-sub-nav--open');
    });
}

/**
 * to top link
 */
const toTop = document.getElementById("back-to-top-link");

window.addEventListener("scroll", scrollFunction);

function scrollFunction() {
    const viewHeight = window.innerHeight;
    
    if (document.body.scrollTop > viewHeight || document.documentElement.scrollTop > viewHeight) {
    toTop.style.display = "block";
  } else {
    toTop.style.display = "none";
  }
}
